// // Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { useState } from 'react'

import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'

import { TimeStep } from '@shared/Enums'

export default function ReportDateStepPicker(props: {
  onSelectedChange: (timeStep: TimeStep) => void
  forEvents: boolean
}): React.ReactElement {
  const [timeStep, setTimeStep] = useState<TimeStep>(TimeStep.Day)

  const localTimeStrep = (newTimeStep: TimeStep) => {
    if (newTimeStep) {
      setTimeStep(newTimeStep)
      props.onSelectedChange(newTimeStep)
    }
  }

  return (
    <Box sx={{ flexGrow: 0, width: 275, flexDirection: 'column', display: 'flex', marginBottom: 6 }}>
      <Typography sx={{ marginTop: -1, marginBottom: 1, height: 24 }} variant="caption">
        Time Step
      </Typography>
      <FormControl sx={{ m: 0, width: 420, padding: 0 }} size="medium">
        <Select
          label="Time Step"
          value={timeStep}
          onChange={(event: SelectChangeEvent) => {
            localTimeStrep(event.target.value as TimeStep)
          }}
        >
          <MenuItem value={TimeStep.Minute}>Minute</MenuItem>
          <MenuItem value={TimeStep.FifteenMinutes}>Fifteen Minutes</MenuItem>
          <MenuItem value={TimeStep.Hour}>Hour</MenuItem>
          <MenuItem value={TimeStep.Day}>Day</MenuItem>
          <MenuItem value={TimeStep.Week}>Week</MenuItem>
        </Select>
      </FormControl>
    </Box>
  )
}
